import '@stimulus/polyfills'
import '../src/utils/localStorage_protection'
import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import Chart from 'stimulus-chartjs'
import AsyncFrameController from '../src/common/async_frame_controller'

function importAll (r) {
  r.keys().forEach(r)
}
importAll(require.context('../../components/site/pages/facility', true, /desktop\/component\.js$/))
importAll(require.context('../../components/site/pages/facility', true, /desktop\/component\.js$/))
importAll(require.context('../../components/site/parts', true, /desktop\/component\.js$/))
importAll(require.context('../src/common', true, /.*\.js$/))

const application = Application.start()
application.register('chart', Chart)
// 非同期フレームコントローラーを登録（Turbo Frameの代替）
application.register('async-frame', AsyncFrameController)
application.load(definitionsFromContext(require.context('../../components/site/pages/facility', true, /desktop\/component_controller\.js$/)))
application.load(definitionsFromContext(require.context('../../components/site/pages/facility', true, /desktop\/component_controller\.js$/)))
application.load(definitionsFromContext(require.context('../../components/site/parts', true, /desktop\/component_controller\.js$/)))

const images = require.context('../images', true)
export { images }
